import { render, staticRenderFns } from "./Lightning.vue?vue&type=template&id=454e4cb7"
import script from "./Lightning.vue?vue&type=script&lang=js"
export * from "./Lightning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports